import {
  CAUHINHGSM_COUNT_ASSIGN_SUCCESS,
  CAUHINHGSM_HISTORY_LIST_SUCCESS,
  CAUHINHGSM_IMPORT_SUCCESS,
  CAUHINHGSM_LIST_SUCCESS,
  CAUHINHGSM_NEW_CARE_SUCCESS,
  CAUHINHGSM_ONE_SUCCESS,
  CAUHINHGSM_UPDATE_FILTER,
  CAUHINHGSMCOMLIST_LIST_SUCCESS,
} from 'src/actions/cauhinhgsm.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import dayjs from 'dayjs';

const today = new Date();

const initState = {
  filter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  cauhinhgsmcomlist_items: [],
  cauhinhgsmcomlist_total: 0,
  temp: [],
  selected: undefined,
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0
}

const cauhinhgsmReducer = (state = initState, action) => {
  switch (action.type) {
    case CAUHINHGSM_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case CAUHINHGSMCOMLIST_LIST_SUCCESS: {
      console.log({
        cauhinhgsmcomlist_items: action.data.items,
        cauhinhgsmcomlist_total: action.data.total,
      })
      return {
        ...state,
        cauhinhgsmcomlist_items: action.data.items,
        cauhinhgsmcomlist_total: action.data.total,
      }
    }
    case CAUHINHGSM_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case CAUHINHGSM_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case CAUHINHGSM_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case CAUHINHGSM_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case CAUHINHGSM_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case CAUHINHGSM_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    default: {
      return state;
    }
  }
}
export default cauhinhgsmReducer